export default __webpack_public_path__ + "static/media/feature-mngd-services-3.36e1face.png";